import { forOwn, get, isArray, set } from 'lodash';
import { getFieldNamefromDataPath, removeIdsFromArrayObjects } from './helper';

// import Schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import OrgaSchema from 'src/lib/paths/organisation_FULL_Paths.json';
const AP = AntragSchema.attributes;
const OP = OrgaSchema.attributes;

export const getOrgaDateFuerAntrag = (orgaOriginalData: any) => {
	let result: any = {};

	forOwn(ORGA_ANTRAG_FELDER_MAPPING, (orgaPath: string, antragPath: string) => {
		let value = get(orgaOriginalData, orgaPath, null);

		if (orgaPath === OP.Unternehmensprofil_Vertr_0045070791_ektbeantragung_Undabwicklung.path) {
			value = isArray(value) && value.length > 0 ? removeIdsFromArrayObjects(value) : [];
		}

		if (orgaPath === OP.Unternehmensprofil_Zeichnungsberechtigte.path || orgaPath === OP.Unternehmensprofil_Ansprechpartnerin.path) {
			value = isArray(value) && value.length > 0 ? removeIdsFromArrayObjects(value) : [{ Vorname: '' }];
		}

		set(result, getFieldNamefromDataPath(antragPath), value);
	});

	return result;
};

const ORGA_ANTRAG_FELDER_MAPPING = {
	[AP.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path]: OP.Geschaeftsbezogene_Daten_Name_Der_Organisation.path,
	[AP.Antragstellende_Organisation_Rechtsform_Der_Organisation.path]: OP.Geschaeftsbezogene_Daten_Rechtsform_Der_Organisation.path,

	// Address daten
	[AP.Antragstellende_Organisation_Strasse_Und_Hausnummer.path]: OP.Adressdaten_Strasse_Und_Hausnummer.path,
	[AP.Antragstellende_Organisation_Adresszusatz.path]: OP.Adressdaten_Adresszusatz.path,
	[AP.Antragstellende_Organisation_PLZ.path]: OP.Adressdaten_PLZ.path,
	[AP.Antragstellende_Organisation_Ort.path]: OP.Adressdaten_Ort.path,
	[AP.Antragstellende_Organisation_Landkreis.path]: OP.Adressdaten_Landkreis_Kreisfreie_Stadt.path,

	// Kontakt Daten
	[AP.Antragstellende_Organisation_Telefonnummer.path]: OP.Kontaktdaten_Telefon.path,
	[AP.Antragstellende_Organisation_E_Mail_Adresse.path]: OP.Kontaktdaten_E_Mail.path,

	// Ansprechpartner Und Vertretungsberechtigte
	// [AP.Antragstellende_Organisation_Ansprechpartnerin.path]: OP.Unternehmensprofil_Ansprechpartnerin.path,
	[AP.Antragstellende_Organisation_Zeichnungsberechtigte.path]: OP.Unternehmensprofil_Zeichnungsberechtigte.path,

	// Bankdaten
	// [AP.Antragstellende_Organisation_Bankverbindung_Kontoinhaber.path]: OP.Bankdaten_Kontoinhaber.path,
	// [AP.Antragstellende_Organisation_Bankverbindung_Geldinstitut.path]: OP.Bankdaten_Geldininstitut.path,
	// [AP.Antragstellende_Organisation_Bankverbindung_IBAN.path]: OP.Bankdaten_IBAN.path,
	// [AP.Antragstellende_Organisation_Bankverbindung_BIC.path]: OP.Bankdaten_BIC.path,

	// Unternehmensprofil Rest-Felder
	[AP.Antragstellende_Organisation_Name_Des_Geschaeftsfuehrers.path]: OP.Unternehmensprofil_Name_Des_Geschaeftsfuehrers.path,
	[AP.Antragstellende_Organisation_Handelsregisternummer.path]: OP.Unternehmensprofil_Handelsregisternummer.path,
	[AP.Antragstellende_Organisation_U_St_Id_Nr.path]: OP.Unternehmensprofil_U_St_Id_Nr.path,
	[AP.Antragstellende_Organisation_Steuernummer.path]: OP.Unternehmensprofil_Steuernummer.path,
	[AP.Antragstellende_Organisation_Registergericht.path]: OP.Unternehmensprofil_Registergericht.path,
	[AP.Antragstellende_Organisation_Gruendungsdatum.path]: OP.Unternehmensprofil_Gruendungsdatum.path,
	[AP.Antragstellende_Organisation_Oeffentlicher_Auftraggeber.path]: OP.Unternehmensprofil_Oeffentlicher_Auftraggeber.path,
	[AP.Antragstellende_Organisation_Sektorenauftraggeber.path]: OP.Unternehmensprofil_Sektorenauftraggeber.path,
	[AP.Antragstellende_Organisation_Oe_PNV_Lizenz_Vorhanden.path]: OP.Unternehmensprofil_Oe_PNV_Lizenz_Vorhanden.path,
	[AP.Antragstellende_Organisa_0252192846_fuehrung_Von_Ausschreibungen.path]:
		OP.Unternehmensprofil_Verpf_0050602990_fuehrung_Von_Ausschreibungen.path,

	// Vorsteuerabzug berechtige
	[AP.Antragstellende_Organisation_Angaben_Zum_Vorsteuerabzug.path]: OP.Unternehmensprofil_Angaben_Zum_Vorsteuerabzug.path,
	//Prozentual entfernt HA-2331
	// [AP.Antragstellende_Organisa_0036308444_chtigung_prozentualer_Anteil.path]:
	// 	OP.Unternehmensprofil_Vorst_0237375484_chtigung_prozentualer_Anteil.path,

	//Steuerinformationen
	[AP.Antragstellende_Organisation_Wirtschafts_Identifikationsnummer.path]: OP.Unternehmensprofil_Wirtschafts_Identifikationsnummer.path,

	// Abweichende Sitz
	// [AP.Antragstellende_Organisation_Abweichender_Sitz.path]: OP.Adressdaten_Abweichender_Sitz.path,
	// [AP.Antragstellende_Organisa_0234235106_resse_Strasse_Und_Hausnummer.path]: OP.Adressdaten_Abweichender_Sitz_Adresse_Strasse_Und_Hausnummer.path,
	// [AP.Antragstellende_Organisation_Abweichender_Sitz_Adresse_PLZ.path]: OP.Adressdaten_Abweichender_Sitz_Adresse_PLZ.path,
	// [AP.Antragstellende_Organisation_Abweichender_Sitz_Adresse_Ort.path]: OP.Adressdaten_Abweichender_Sitz_Adresse_Ort.path,
	// [AP.Antragstellende_Organisa_0220666052_e_Landkreis_Kreisfreie_Stadt.path]:
	// 	OP.Adressdaten_Abweichender_Sitz_Adresse_Landkreis_Kreisfreie_Stadt.path,
	// [AP.Antragstellende_Organisa_0136641499_itz_Adresse_Regierungsbezirk.path]: OP.Adressdaten_Abweichender_Sitz_Adresse_Regierungsbezirk.path,
	// [AP.Antragstellende_Organisation_Abweichender_Sitz_Adresse_Region.path]: OP.Adressdaten_Abweichender_Sitz_Adresse_Region.path,

	// in i-taros fehlende Felder
	// [AP.Antragstellende_Organisa_0112686157_sstaette_Im_Laendlichen_Raum.path]: OP.Geschaeftsbezogene_Daten_Name_Der_Organisation.path,
	// [AP.Antragstellende_Organisa_0099968647_ionell_Gefoerdert_Foerderung.path]: OP.Geschaeftsbezogene_Daten_Name_Der_Organisation.path,
	// [AP.Antragstellende_Organisa_0262845644_foerdert_prozentualer_Anteil.path]: OP.Geschaeftsbezogene_Daten_Name_Der_Organisation.path,
	// [AP.Antragstellende_Organisa_0252192846_fuehrung_Von_Ausschreibungen.path]: OP.Adressdaten_Strasse_Und_Hausnummer.path,
};
